import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import BadgeIcon from "@mui/icons-material/Badge";
import StoreIcon from "@mui/icons-material/Store";
import InfoIcon from "@mui/icons-material/Info";
import EventIcon from "@mui/icons-material/Event";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BusinessIcon from "@mui/icons-material/Business";
import FolderIcon from "@mui/icons-material/Folder";
import PhoneIcon from "@mui/icons-material/Phone";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import HouseIcon from "@mui/icons-material/House";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ApartmentIcon from "@mui/icons-material/Apartment";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import { FaDollarSign } from "react-icons/fa";
import { PiMoneyWavyBold } from "react-icons/pi";
import axios from "../../configApi/axiosConfig";
import { APIURL } from "../../configApi/apiConfig";

const ESTADOS_SOLICITUD = {
  1: { etiqueta: "PRE-APROBADO", clase: "bg-blue-100 text-blue-800 border-blue-200" },
  2: { etiqueta: "APROBADO", clase: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  4: { etiqueta: "RECHAZADO", clase: "bg-rose-100 text-rose-800 border-rose-200" },
  6: { etiqueta: "FACTURADO", clase: "bg-purple-100 text-purple-800 border-purple-200" },
};

function formatDateTime(dateString) {
  if (!dateString) return null;
  const fecha = new Date(dateString);
  if (isNaN(fecha.getTime())) return null;
  return fecha.toLocaleString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function calcularTiempoTranscurrido(fechaInicial, fechaFinal) {
  if (!fechaInicial || !fechaFinal) return "N/A";
  const inicio = new Date(fechaInicial);
  const fin = new Date(fechaFinal);
  if (isNaN(inicio.getTime()) || isNaN(fin.getTime())) return "N/A";

  const diferencia = fin - inicio;
  const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
  const horas = Math.floor((diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));

  if (dias > 0) return `${dias}d ${horas}h ${minutos}min`;
  if (horas > 0) return `${horas}h ${minutos}min`;
  return `${minutos}min`;
}

// Mismo cálculo de respaldo que usa VerDetallesModal cuando no hay timers en
// pantalla para sumar (aquí no hay DOM que medir, así que es el único cálculo).
function calcularTiempoTotal(fechaTiempos) {
  const tiempos = [];

  if (fechaTiempos?.tipo1?.length > 1) {
    tiempos.push(calcularTiempoTranscurrido(fechaTiempos.tipo1[0]?.FechaSistema, fechaTiempos.tipo1[1]?.FechaSistema));
  }
  if (
    fechaTiempos?.tipo3?.some((item) => item.idEstadoVerificacionDocumental === 2) &&
    fechaTiempos?.tipo3?.some((item) => item.idEstadoVerificacionDocumental === 4)
  ) {
    tiempos.push(
      calcularTiempoTranscurrido(
        fechaTiempos.tipo3.find((item) => item.idEstadoVerificacionDocumental === 2)?.FechaSistema,
        fechaTiempos.tipo3.find((item) => item.idEstadoVerificacionDocumental === 4)?.FechaSistema
      )
    );
  }
  if (fechaTiempos?.tipo2?.length > 0 && fechaTiempos?.tipo2?.some((item) => item.idEstadoVerificacionDocumental === 3)) {
    tiempos.push(
      calcularTiempoTranscurrido(
        fechaTiempos.tipo2.slice().reverse().find((item) => item.idEstadoVerificacionDocumental === 2)?.FechaSistema,
        fechaTiempos.tipo2.find((item) => item.idEstadoVerificacionDocumental === 3)?.FechaSistema
      )
    );
  }
  if (fechaTiempos?.tipo4?.length > 0 && fechaTiempos?.tipo4?.some((item) => item.idEstadoVerificacionDocumental === 2)) {
    tiempos.push(
      calcularTiempoTranscurrido(
        fechaTiempos.tipo4.find((item) => item.idEstadoVerificacionDocumental === 1)?.FechaSistema,
        fechaTiempos.tipo4.find((item) => item.idEstadoVerificacionDocumental === 2)?.FechaSistema
      )
    );
  }
  if (fechaTiempos?.tipo5?.length > 0 && fechaTiempos?.tipo5?.some((item) => item.idEstadoVerificacionDocumental === 2)) {
    tiempos.push(
      calcularTiempoTranscurrido(
        fechaTiempos.tipo5.find((item) => item.idEstadoVerificacionDocumental === 1)?.FechaSistema,
        fechaTiempos.tipo5.find((item) => item.idEstadoVerificacionDocumental === 2)?.FechaSistema
      )
    );
  }

  if (tiempos.length === 0 || tiempos.every((t) => !t || t === "N/A")) return "0h 0m";
  if (tiempos.length === 1) return tiempos[0];

  let totalMinutos = 0;
  tiempos.forEach((tiempo) => {
    const horasMin = tiempo.match(/(\d+)h\s*(\d+)min/);
    if (horasMin) {
      totalMinutos += parseInt(horasMin[1], 10) * 60 + parseInt(horasMin[2], 10);
      return;
    }
    const soloMin = tiempo.match(/(\d+)min/);
    if (soloMin) {
      totalMinutos += parseInt(soloMin[1], 10);
    }
  });

  const horas = Math.floor(totalMinutos / 60);
  const minutos = totalMinutos % 60;
  return horas > 0 ? `${horas}h ${minutos}min` : `${minutos}min`;
}

const estadoMap = {
  1: "PENDIENTE",
  10: "REVISIÓN",
  11: "CORRECIÓN",
  12: "APROBADO",
  13: "RECHAZADO",
};
const estadoDocumentalMap = {
  1: "PROCESO",
  2: "REVISIÓN",
  3: "CORRECIÓN",
  4: "APROBACION",
};
const estadoTelefonicaMap = {
  1: "NO ASIGNADO",
  2: "ASIGNADO",
  3: "APROBADO",
  4: "RECHAZADO",
  7: "CORRECCION"
};
const DomicilioLaboralMap = {
  1: "ASIGNADO",
  2: "DATOS VERIFICADOR",
  3: "RECHAZA VERIFICADOR",
  4: "APROBADO ANALISTA",
  5: "RECHAZA ANALISTA",
};

function PasoTimeline({ Icono, color, titulo, fechaInicio, fechaFin, tiempo, estadoActual }) {
  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-col items-center gap-1 mb-2 h-5">
        {fechaInicio && (
          <span className={`px-2 py-0.5 ${color.claro} rounded text-[10px] font-semibold border`}>{fechaInicio}</span>
        )}
      </div>
      <div className={`w-10 h-10 rounded-full ${color.solido} flex items-center justify-center shadow-md border-2 border-white`}>
        <Icono sx={{ fontSize: 18, color: "white" }} />
      </div>
      <p className="mt-2 text-xs font-bold text-gray-700 uppercase tracking-wide text-center">{titulo}</p>
      {estadoActual && (
        <p className="text-[10px] font-semibold text-blue-600 uppercase tracking-wide mt-1 text-center">
          {estadoActual}
        </p>
      )}
      <div className="flex flex-col items-center gap-1 mt-2 min-h-[40px]">
        {fechaFin && (
          <>
            <span className={`px-2 py-0.5 ${color.claro} rounded text-[10px] font-semibold border`}>{fechaFin}</span>
            <span className={`px-2 py-1 ${color.solido} text-white rounded-full text-[10px] font-bold shadow-sm`}>{tiempo}</span>
          </>
        )}
      </div>
    </div>
  );
}

function Campo({ Icono, color, etiqueta, valor, resaltado }) {
  return (
    <div className={`p-2.5 rounded-lg border transition-shadow hover:shadow-md ${resaltado || "bg-slate-50 border-slate-200"}`}>
      <div className="flex items-center gap-2">
        <div className={`shrink-0 w-7 h-7 rounded-lg flex items-center justify-center ${color}`}>
          <Icono sx={{ fontSize: 16 }} className="text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] text-slate-600 font-semibold uppercase tracking-wide">{etiqueta}</p>
          <p className="text-xs font-bold text-gray-900 truncate">{valor ?? "—"}</p>
        </div>
      </div>
    </div>
  );
}

export function SeguimientoModal({ open, onClose, solicitud }) {
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState(null);
  const [cuota, setCuota] = useState(null);
  const [solicitudDetalle, setSolicitudDetalle] = useState(null);
  const [fechaTiempos, setFechaTiempos] = useState(null);

  useEffect(() => {
    if (!open || !solicitud?.idCreSolicitudWeb) return;

    let cancelado = false;
    const id = solicitud.idCreSolicitudWeb;

    const cargarSeguimiento = async () => {
      setCargando(true);
      setError(null);
      try {
        const [cuotaResp, solWebResp, tipo1, tipo2, tipo3, tipo4, tipo5] = await Promise.all([
          axios.get(APIURL.getSolicitudGrandeporId(id)),
          axios.get(APIURL.getConsultaCre_solicitud_web(id)),
          axios.get(APIURL.get_TiempSolicWeb(1, id, "10,12")),
          axios.get(APIURL.get_TiempSolicWeb(2, id, "2,3")),
          axios.get(APIURL.get_TiempSolicWeb(3, id, "2,4")),
          axios.get(APIURL.get_TiempSolicWeb(4, id, "1")),
          axios.get(APIURL.get_TiempSolicWeb(5, id, "1")),
        ]);

        if (cancelado) return;
        setCuota(cuotaResp?.data?.CuotaAsignada ?? null);
        setSolicitudDetalle(solWebResp?.data || null);
        setFechaTiempos({
          tipo1: tipo1?.data || [],
          tipo2: tipo2?.data || [],
          tipo3: tipo3?.data || [],
          tipo4: tipo4?.data || [],
          tipo5: tipo5?.data || [],
        });
      } catch (err) {
        if (!cancelado) setError("No se pudo cargar el seguimiento de esta solicitud.");
      } finally {
        if (!cancelado) setCargando(false);
      }
    };

    cargarSeguimiento();
    return () => {
      cancelado = true;
    };
  }, [open, solicitud?.idCreSolicitudWeb]);

  if (!solicitud) return null;

  const estado = ESTADOS_SOLICITUD[solicitud.estado] || { etiqueta: "DESCONOCIDO", clase: "bg-slate-100 text-slate-700 border-slate-200" };

  const t1Inicio = formatDateTime(fechaTiempos?.tipo1?.[0]?.FechaSistema);
  const t1Fin = formatDateTime(fechaTiempos?.tipo1?.[1]?.FechaSistema);
  const t3Inicio = formatDateTime(fechaTiempos?.tipo3?.find((i) => i.idEstadoVerificacionDocumental === 2)?.FechaSistema);
  const t3Fin = formatDateTime(fechaTiempos?.tipo3?.find((i) => i.idEstadoVerificacionDocumental === 4)?.FechaSistema);
  const t2Inicio = formatDateTime(
    fechaTiempos?.tipo2?.slice().reverse().find((i) => i.idEstadoVerificacionDocumental === 2)?.FechaSistema
  );
  const t2Fin = formatDateTime(fechaTiempos?.tipo2?.find((i) => i.idEstadoVerificacionDocumental === 3)?.FechaSistema);
  const t4Inicio = formatDateTime(fechaTiempos?.tipo4?.find((i) => i.idEstadoVerificacionDocumental === 1)?.FechaSistema);
  const t4Fin = formatDateTime(fechaTiempos?.tipo4?.find((i) => i.idEstadoVerificacionDocumental === 2)?.FechaSistema);
  const t5Inicio = formatDateTime(fechaTiempos?.tipo5?.find((i) => i.idEstadoVerificacionDocumental === 1)?.FechaSistema);
  const t5Fin = formatDateTime(fechaTiempos?.tipo5?.find((i) => i.idEstadoVerificacionDocumental === 2)?.FechaSistema);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent className="!p-0 max-h-[78vh] overflow-y-auto bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-700 px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-white/20 rounded-xl">
              <PendingActionsIcon sx={{ fontSize: 18, color: "white" }} />
            </div>
            <h2 className="text-lg font-bold text-white">Seguimiento de Solicitud</h2>
            <span className={`px-2 py-0.5 rounded-full text-[11px] font-bold border ${estado.clase}`}>{estado.etiqueta}</span>
          </div>
          <div className="px-4 py-1 bg-white/20 rounded-xl border border-white/30">
            <div className="text-[10px] font-semibold text-blue-100 uppercase tracking-wide">Tiempo Total</div>
            <div className="text-sm font-bold text-white">{cargando ? "…" : calcularTiempoTotal(fechaTiempos)}</div>
          </div>
        </div>

        <div className="bg-gradient-to-b from-gray-50 to-white px-6 py-5 border-b-2 border-gray-200">
          <div className="relative">
            <div className="absolute left-0 right-0 top-[35%] h-1 bg-gradient-to-r from-blue-200 via-indigo-200 to-purple-200 rounded-full" />
            <div className="grid grid-cols-5 gap-2 relative z-10">
              <PasoTimeline
                Icono={PendingActionsIcon}
                color={{ solido: "bg-gradient-to-br from-slate-600 to-slate-700", claro: "bg-blue-50 text-blue-700 border-blue-200" }}
                titulo="Solicitud"
                fechaInicio={t1Inicio}
                fechaFin={t1Fin}
                tiempo={calcularTiempoTranscurrido(fechaTiempos?.tipo1?.[0]?.FechaSistema, fechaTiempos?.tipo1?.[1]?.FechaSistema)}
                estadoActual={solicitudDetalle?.idEstadoVerificacionSolicitud ? estadoMap[solicitudDetalle.idEstadoVerificacionSolicitud] : ""}
              />
              <PasoTimeline
                Icono={FolderIcon}
                color={{ solido: "bg-gradient-to-br from-blue-800 to-blue-900", claro: "bg-green-50 text-green-700 border-green-200" }}
                titulo="Documental"
                fechaInicio={t3Inicio}
                fechaFin={t3Fin}
                tiempo={calcularTiempoTranscurrido(t3Inicio && fechaTiempos?.tipo3?.find((i) => i.idEstadoVerificacionDocumental === 2)?.FechaSistema, fechaTiempos?.tipo3?.find((i) => i.idEstadoVerificacionDocumental === 4)?.FechaSistema)}
                estadoActual={solicitudDetalle?.idEstadoVerificacionDocumental && solicitud.foto && solicitud.foto !== "prueba" ? estadoDocumentalMap[solicitudDetalle.idEstadoVerificacionDocumental] : ""}
              />
              <PasoTimeline
                Icono={PhoneInTalkIcon}
                color={{ solido: "bg-gradient-to-br from-slate-600 to-slate-700", claro: "bg-purple-50 text-purple-700 border-purple-200" }}
                titulo="Telefónica"
                fechaInicio={t2Inicio}
                fechaFin={t2Fin}
                tiempo={calcularTiempoTranscurrido(fechaTiempos?.tipo2?.slice().reverse().find((i) => i.idEstadoVerificacionDocumental === 2)?.FechaSistema, fechaTiempos?.tipo2?.find((i) => i.idEstadoVerificacionDocumental === 3)?.FechaSistema)}
                estadoActual={solicitudDetalle?.idEstadoVerificacionTelefonica ? estadoTelefonicaMap[solicitudDetalle.idEstadoVerificacionTelefonica] : ""}
              />
              <PasoTimeline
                Icono={HouseIcon}
                color={{ solido: "bg-gradient-to-br from-blue-800 to-blue-900", claro: "bg-amber-50 text-amber-700 border-amber-200" }}
                titulo="Domicilio"
                fechaInicio={t4Inicio}
                fechaFin={t4Fin}
                tiempo={calcularTiempoTranscurrido(fechaTiempos?.tipo4?.find((i) => i.idEstadoVerificacionDocumental === 1)?.FechaSistema, fechaTiempos?.tipo4?.find((i) => i.idEstadoVerificacionDocumental === 2)?.FechaSistema)}
                estadoActual={solicitudDetalle?.idEstadoVerificacionDomicilio ? DomicilioLaboralMap[solicitudDetalle.idEstadoVerificacionDomicilio] : ""}
              />
              <PasoTimeline
                Icono={ApartmentIcon}
                color={{ solido: "bg-gradient-to-br from-slate-600 to-slate-700", claro: "bg-rose-50 text-rose-700 border-rose-200" }}
                titulo="Trabajo"
                fechaInicio={t5Inicio}
                fechaFin={t5Fin}
                tiempo={calcularTiempoTranscurrido(fechaTiempos?.tipo5?.find((i) => i.idEstadoVerificacionDocumental === 1)?.FechaSistema, fechaTiempos?.tipo5?.find((i) => i.idEstadoVerificacionDocumental === 2)?.FechaSistema)}
                estadoActual={solicitudDetalle?.idEstadoVerificacionTerrena ? DomicilioLaboralMap[solicitudDetalle.idEstadoVerificacionTerrena] : ""}
              />
            </div>
          </div>
          {error && <p className="mt-3 text-xs text-rose-600 font-medium">{error}</p>}
        </div>

        <div className="px-6 py-5 flex flex-col lg:flex-row gap-6">
          <div className="lg:w-1/3">
            <div className="bg-white rounded-2xl shadow-md p-4 border border-gray-200">
              <div className="w-full aspect-square rounded-xl overflow-hidden border-4 border-gray-200 bg-gradient-to-br from-gray-100 to-gray-200">
                {solicitud.foto && solicitud.foto !== "prueba" ? (
                  <img src={solicitud.foto} alt="Foto del cliente" className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-20 w-20 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5.121 17.804A9 9 0 0112 15a9 9 0 016.879 2.804M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="lg:w-2/3">
            <div className="bg-white rounded-2xl shadow-md p-4 border border-gray-200">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <Campo Icono={BadgeIcon} color="bg-blue-900" etiqueta="Cédula" valor={solicitud.cedula} />
                <Campo Icono={InfoIcon} color="bg-slate-700" etiqueta="Vendedor" valor={solicitud.vendedor} />
                <Campo Icono={PhoneIcon} color="bg-blue-900" etiqueta="Celular" valor={solicitud.celular} />
                <Campo Icono={EventIcon} color="bg-slate-700" etiqueta="Fecha" valor={solicitud.fecha?.substring?.(0, 10)} />
                <Campo Icono={CheckCircleIcon} color="bg-blue-900" etiqueta="Afiliado" valor={solicitud.afiliado ? "Sí" : "No"} />
                <Campo Icono={BusinessIcon} color="bg-slate-700" etiqueta="Tiene RUC" valor={solicitud.tieneRuc ? "Sí" : "No"} />
                <Campo Icono={StoreIcon} color="bg-slate-700" etiqueta="Almacén" valor={solicitud.almacen} />
                <Campo Icono={ShoppingCartIcon} color="bg-blue-900" etiqueta="Producto" valor={solicitud.producto} />
                <Campo Icono={FingerprintIcon} color="bg-blue-900" etiqueta="Código Dactilar" valor={solicitud.codigoDactilar} />
                <Campo Icono={FaDollarSign} color="bg-slate-700" etiqueta="Cuota" valor={cuota} />
                <Campo
                  Icono={PiMoneyWavyBold}
                  color={Number(solicitud.entrada) > 0 ? "bg-amber-600" : "bg-blue-900"}
                  etiqueta="% Entrada"
                  valor={Number(solicitud.entrada || 0).toFixed(2)}
                  resaltado={Number(solicitud.entrada) > 0 ? "bg-amber-50 border-amber-300" : undefined}
                />
              </div>
            </div>
          </div>
        </div>
      </DialogContent>

      <DialogActions className="!p-3 bg-gradient-to-r from-gray-50 to-blue-50 border-t-2 border-gray-200">
        <button
          onClick={onClose}
          className="flex items-center gap-2 px-8 py-2 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white font-bold rounded-xl shadow-lg transition-all"
        >
          Cerrar
        </button>
      </DialogActions>
    </Dialog>
  );
}
